import { css } from 'styled-system/css';

export const toTopButtonStyle = {
	root: css({
		_mars: {
			bgColor: 'blackOpacity.38',
		}
	})
}